import { render } from "./JobspecialServiceNumber.vue?vue&type=template&id=c7d22360&scoped=true"
import script from "./JobspecialServiceNumber.vue?vue&type=script&lang=js"
export * from "./JobspecialServiceNumber.vue?vue&type=script&lang=js"

import "./JobspecialServiceNumber.vue?vue&type=style&index=0&id=c7d22360&scoped=true&lang=css"
import "./JobspecialServiceNumber.vue?vue&type=style&index=1&id=c7d22360&lang=css"
script.render = render
script.__scopeId = "data-v-c7d22360"

export default script